import {HiOutlineMail} from 'react-icons/hi'
import { RiMessengerLine } from 'react-icons/ri'
import { FaWhatsapp } from 'react-icons/fa'

const data = [
    {id: 1, icon: <HiOutlineMail/>, link: "mailto: borset53@gmail.com"},
    {id: 2, icon: <RiMessengerLine/>, link: "https://www.messenger.com/t/100079734289772"},
    {id: 3, icon: <FaWhatsapp/>, link: "https://wa.me/+918412911410"},
]

//alternate whatsapp link
//https://wa.me/yournumber

export default data;